import { httpClient } from "@/app/client/httpClient";

class LocalitiesService {
  loadLocalities(prefecture: string) {
    return httpClient.localities.$get({
      query: { prefecture, limit: 9999 }
    });
  }
  searchPostalCode(postalCode: string) {
    return httpClient.localities.postal_code.search.get({
      /* eslint-disable @typescript-eslint/naming-convention */
      query: { postal_code: postalCode }
    });
  }
  fetchLocalitiesWithSeirei(prefectureId: number) {
    return httpClient.localities.list_with_seirei.$get({
      query: { prefecture_id: prefectureId }
    });
  }
}

export const localitiesService = new LocalitiesService();
